module.exports = __webpack_public_path__ + "static/dummy.landscape-3f8e084a0ba1724d3584bff0b835942f.png";